import { TFunction } from 'i18next';
import { CategoryResponse, TreeNode } from 'types/productsTypes';
import { translateProductLabel } from 'utils/product';

export function transformToTreeProduct(
  data: CategoryResponse[] | undefined,
  t: TFunction
): TreeNode[] {
  return (
    data?.map(
      (category): TreeNode => ({
        title: translateProductLabel(
          t,
          'commodity',
          category.translationKey,
          category.name
        ),
        value: category.id,
        key: category.id,
        selectable: false,
        children: category.varieties?.map(variety => ({
          title: translateProductLabel(
            t,
            'variety',
            variety.translationKey,
            variety.name
          ),
          value: variety.id,
          key: variety.id,
          selectable: false,
          children: variety.products?.map(product => ({
            title: translateProductLabel(
              t,
              'product',
              product.translationKey,
              product.name
            ),
            value: product.id,
            key: product.id,
            selectable: true,
          })),
        })),
      })
    ) ?? []
  );
}
